import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = createClient({
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
    dataset: 'production',
    apiVersion: '2023-04-01',
    useCdn: false,
    token: process.env.REACT_APP_SANITY_TOKEN 
})

//code when working with images in sanity
const builder = imageUrlBuilder(client)
export const urlFor = (source) => builder.image(source);